import { memo } from 'react'
import { styled } from '@mui/material/styles'
import schufa from '../../assets/logos/schufa.svg'
import schufaGreen from '../../assets/logos/schufa-green.svg'

export const SchufaLogoContainer = styled('div')({
  textAlign: 'center'
})

interface Props {
  width?: string
  variant?: 'default' | 'green'
  withLink?: boolean
}

const SchufaLogo = ({
  width,
  variant = 'default',
  withLink = variant === 'default'
}: Props) => {
  const image = (
    <img
      src={variant === 'green' ? schufaGreen : schufa}
      width={width}
      alt="100% Schufaneutral"
    />
  )

  if (!withLink) {
    return image
  }

  return (
    <SchufaLogoContainer>
      <a
        href="https://www.finanzcheck.de/faq/schufaneutral/"
        target="_blank"
        rel="noreferrer noopener"
      >
        {image}
      </a>
    </SchufaLogoContainer>
  )
}

export default memo(SchufaLogo)
